module.exports = __webpack_public_path__ + "img/sld_scb_1_t1_b1_green.cdfc0734.svg";